import * as XLSX from "xlsx";

/**
 * FORMATEAR HEADERS
 * Limpia y capitaliza las llaves de los objetos para que se vean bien en el Excel.
 */
export const formatKey = (key) => {
    if (["month", "company", "company_type"].includes(key)) {
        return key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
    }

    const withoutId = key.replace(/^\d+__/, ""); // quitar el ID inicial
    const step2 = withoutId.replace(/__/g, " - "); // convertir "__" en " - "
    const step3 = step2.replace(/_/g, " "); // "_" a espacio

    const final = step3.replace(/\b\w/g, c => c.toUpperCase()); // capitalizar cada palabra

    return final;
};

/**
 * TRANSFORMAR OBJETOS PARA EXCEL
 * Crea un nuevo objeto con las llaves formateadas.
 */
export const transformDataForExcel = (data) => {
    if (!Array.isArray(data)) return [];
    
    return data.map(item => {
        const newItem = {};
        Object.keys(item).forEach(key => {
            newItem[formatKey(key)] = item[key];
        });
        return newItem;
    });
};

/**
 * EXPORTAR EXCEL
 * Genera y descarga el archivo .xlsx
 */
export const exportToExcel = (data, fileName = "Reporte") => {
    const transformed = transformDataForExcel(data);

    const worksheet = XLSX.utils.json_to_sheet(transformed);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

    // Descarga el archivo
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};